import EditUserIcon from 'assets/images/settingFund/edit-user.svg'
import ManageCardIcon from 'assets/images/settingFund/manage-card.svg'
import RoleIcon from 'assets/images/settingFund/role.svg'
import TranpancyIcon from 'assets/images/settingFund/transpancy.svg'
import TranspancySendIcon from 'assets/images/settingFund/transpanvy-send.svg'
interface IList {
    title: string
    icon: string
    route: string
    subtext?: string
    disable: boolean
}
export const myLists: Array<IList> = [
    {
        title: 'مدیریت حساب',
        icon: ManageCardIcon,
        route: '/fund/setting/manage/',
        disable: false,
    },
    {
        title: 'ویرایش اطلاعات اعضا',
        icon: EditUserIcon,
        route: '/fund/setting/users-information/',
        disable: false,
    },
    {
        title: 'اساسنامه',
        icon: RoleIcon,
        route: '',
        disable: true,
    },
    {
        title: 'شفافیت اطلاعات صندوق',
        icon: TranpancyIcon,
        route: '/fund/setting/member-transparency/',
        disable: false,
    },
    {
        title: 'شفافیت ارسال اعلان های صندوق',
        icon: TranspancySendIcon,
        route: '/fund/setting/member-sms/',
        subtext: 'پیامک، نوتیفیکیشن و پیام درون برنامه ای',
        disable: false,
    },
]
